import { Box, Text } from "@chakra-ui/react"
import { alertSeverityConfig } from "@hydrologiq/shared/components/AlertSeverityBadge"
import { NodeAlertSummary } from "../../../types/SystemView"
import { useNavigate, useParams } from "react-router-dom"

interface AlertBadgeProps {
  alerts: NodeAlertSummary
  assetId: string
  assetName: string
}

function AlertBadge({ alerts, assetId }: AlertBadgeProps) {
  const hasAlerts = alerts.total > 0
  const severity = alerts.highestSeverity || "ok"
  const config = alertSeverityConfig[severity]
  const navigate = useNavigate()
  const { systemId } = useParams<{ systemId: string }>()

  const handleClick = () => {
    if (hasAlerts && systemId) {
      navigate(`/systems/${systemId}/alerts?highlight=${assetId}`)
    }
  }

  return (
    <Box
      position="absolute"
      top="-14px"
      left="3%"
      transform="translateX(0%)"
      zIndex={10}
      height="14px"
      width={"fit-content"}
      px={"3px"}
      backgroundColor={config.backgroundColor}
      cursor={hasAlerts ? "pointer" : "default"}
      onClick={handleClick}
    >
      <Text
        height="100%"
        alignContent={"center"}
        fontSize="8px"
        textDecoration={hasAlerts ? "underline" : "none"}
      >
        {hasAlerts ? `${alerts.total} alert${alerts.total > 1 ? "s" : ""}` : "No alerts"}
      </Text>
    </Box>
  )
}

export default AlertBadge
